define.alias("shared/components/shared/ui/social-profile-switcher/item", "preview-grid/components/shared/ui/social-profile-switcher/item");